
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BaseCard',
  props: {
    showInfo: {
      type: Boolean,
      default: true
    },
    to: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    removeDefaultStyle: {
      type: Boolean,
      default: false
    },
    customPadding: {
      type: String,
      default: 'p-3'
    },
    customWidths: {
      type: String,
      default: ''
    }
  },
  computed: {
    attrs() {
      if (this.isExternalLink) {
        return {
          href: this.to,
          rel: 'noopener noreferrer',
          target: '_blank'
        }
      }

      return {
        to: this.to
      }
    },
    elem(): string {
      if (!this.to) {
        return 'div'
      }

      return this.isExternalLink ? 'a' : 'nuxt-link'
    },
    isExternalLink(): boolean {
      return this.to?.startsWith('http') ?? false
    },
    customWidthSplit() {
      const [leftSide = 'w-4/5', rightSide = 'w-1/5'] = this.customWidths.split(' ')
      return [leftSide, rightSide]
    }
  }
})
